import {
  Page,
  Document as PDFDocument,
  StyleSheet as PDFStyleSheet,
  Font,
  View
} from '@react-pdf/renderer'

import { BookingDetail } from '../../../../types/bookingDetails'
import PromotionDetails from '../../PromotionDetails'
import IRANSansFont from '../assets/ttf/IRANSansWeb.ttf'
import NunitoFontBold from '../assets/ttf/Nunito-Bold.ttf'
import NunitoFont from '../assets/ttf/Nunito-Regular.ttf'
import { CancelTermsAndConditions } from './CancelTermsAndConditions'
import Footer from './Footer'
import { ModifyTermsAndConditions } from './ModifyTermsAndConditions'
import { PriceDetails } from './PriceDetails'
import RatePolicy from './RatePolicy'
import RenderParts from './RenderParts/RenderParts'
import { RoomDetails } from './RoomDetails'
import Title from './Title'

Font.register({
  family: 'Nunito',
  fonts: [
    {
      src: NunitoFont,
      fontWeight: 400
    },
    {
      src: NunitoFontBold,
      fontWeight: 700
    }
  ]
})
Font.register({
  family: 'IRANSans',
  fonts: [
    {
      src: IRANSansFont,
      fontWeight: 400
    }
  ]
})

const styles = PDFStyleSheet.create({
  page: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Nunito',
    flexWrap: 'wrap',
    paddingTop: 20,
    paddingBottom: 70,
    paddingHorizontal: 20
  },
  main: {
    flexGrow: 1,
    width: '100%',
    alignItems: 'center'
    // paddingBottom: 10
  },
  roomContianer: {
    marginTop: 10,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
  },
  divider: {
    height: 1,
    width: '90%',
    borderBottom: '1px dashed black',
    marginBottom: 24
  }
})
interface MainPageProps {
  data: BookingDetail
  masterReservationNumber: string
  stripTagsWithNewlines(html: string): string[]
  splitTextByWords(inputString: string, maxLength: number): string[]
}

const MainPage = ({
  data,
  masterReservationNumber,
  stripTagsWithNewlines,
  splitTextByWords
}: MainPageProps) => {
  return (
    <PDFDocument>
      <Page size="A4" style={styles.page}>
        <View style={styles.main}>
          <Title />
          <RenderParts
            data={data}
            masterReservationNumber={masterReservationNumber}
          />
          <PromotionDetails application={data.promotionApplication} />
          {data.rooms.map((item, index) => (
            <View key={index} wrap style={styles.roomContianer}>
              {index !== 0 && <View style={styles.divider} />}
              <RoomDetails
                data={item}
                index={index}
                currency={data.basicDetails.currency}
              />
              <PriceDetails data={item} currency={data.basicDetails.currency} />
              {item.cancellationPolicy.policies &&
                item.cancellationPolicy.policies.length > 0 && (
                  <CancelTermsAndConditions
                    cancelPolicies={item.cancellationPolicy.policies}
                    cancelPolicyDescription={
                      item.cancellationPolicy.description
                        ? stripTagsWithNewlines(
                            item.cancellationPolicy.description
                          )
                        : []
                    }
                    splitTextByWords={splitTextByWords}
                  />
                )}
              {item.modificationPolicy.policies &&
                item.modificationPolicy.policies.length > 0 && (
                  <ModifyTermsAndConditions
                    modifyPolicies={item.modificationPolicy.policies}
                    modifyPolicyDescription={
                      item.modificationPolicy.description
                        ? stripTagsWithNewlines(
                            item.modificationPolicy.description
                          )
                        : []
                    }
                    splitTextByWords={splitTextByWords}
                  />
                )}
              <RatePolicy text={item.ratePolicy || ''} />
            </View>
          ))}
        </View>
        <View
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 50
          }}
          fixed>
          <Footer
            phone={data.basicDetails.propertyTelephone}
            website={data.basicDetails.propertyWebsite}
          />
        </View>
      </Page>
    </PDFDocument>
  )
}

export default MainPage
